import * as z from "zod";

type StringEnum = Readonly<Record<string, string>>;

export const createStringEnumSchema = <const T extends StringEnum>(values: T) =>
  z.enum(values).transform((value): `${T[keyof T]}` => `${value}`);

export const selfServeOnboardingStepsConfigurationFieldSchemas = {
  // HubSpot writes these fields even when they are absent from its payload, so
  // persisted configurations can contain null for any optional field.
  skipBilling: z.boolean().nullish(),
  skipCoverage: z.boolean().nullish(),
  skipPricing: z.boolean().nullish(),
  billingRequired: z.boolean().nullish(),
  enableOnboardingQuestionsForSE: z.boolean().nullish(),
  skipInternational: z.boolean().nullish(),
  skipPackaging: z.boolean().nullish(),
  skipAutomations: z.boolean().nullish(),
  customCoveragePrice: z.number().nullish(),
};
